import { API_FEEDBACK_URL } from "config/global"
import axios from "axios"

export const sendFeedback = async (image: string, category: string) => {
    await axios.post(API_FEEDBACK_URL, {
        file: image,
        category: category,
    })
}
